// import React from 'react';

// function Notes() {
//   return (

//     <div>
//     <p>
//       <strong>A Guide to Critical Cases</strong>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Congratulations on taking the next step in mastering your Emergency
//         Medicine skills! Critical Cases is your virtual EM Oral Boards practice
//         platform, designed to simulate real-world scenarios with an interactive
//         virtual proctor. Whether you’re preparing for exams or sharpening your
//         clinical decision-making, this guide will walk you through how to maximize
//         your experience.
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>Let’s dive in.</span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <strong>Getting Started</strong>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         You’ll interact with the virtual proctor through a{" "}
//       </span>
//       <em>
//         <span style={{ fontWeight: 500 }}>chat/speech</span>
//       </em>
//       <span style={{ fontWeight: 500 }}> interface</span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>Just type (or speak!) your questions and requests.</strong>
//         <span style={{ fontWeight: 500 }}>&nbsp;</span>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         The proctor will respond in real-time, providing details, updates, and
//         test results based on your requests.
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Remember: The order in which you approach the case is crucial. Stick to
//         the structure below for a smooth, logical flow.
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//       <br />
//     </p>
//     <p>
//       <strong>Step-by-Step Guide to Success</strong>
//     </p>
//     <p>&nbsp;</p>
//     <ol>
//       <li>
//         <strong> Entering the Room: Set the Scene</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         We recommend you start every case with this question:
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>
//           “When I walk into the room, what do I see, hear, and smell?”
//         </strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         This will give you your first impression of the patient’s condition and
//         environment. You might hear something like{" "}
//       </span>
//       <em>
//         <span style={{ fontWeight: 500 }}>
//           “The patient appears stated age, resting on the stretcher, appears to be
//           grimacing from pain but otherwise in no significant distress.”
//         </span>
//       </em>
//     </p>
//     <p>
//       <br />
//       <br />
//     </p>
//     <ol start={2}>
//       <li>
//         <strong> Get the Vitals</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Vital signs are….well….vital! Ask for those next!
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>“What are the patient’s vital signs?”</strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Vitals are the foundation of your assessment and will often guide your
//         next steps. If you’re practicing for oral boards, be sure to jot these
//         down on your paper at the top. You will want to navigate the case with
//         this always at the forefront of your mind.&nbsp;
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//     </p>
//     <ol start={3}>
//       <li>
//         <strong> Perform a Primary Survey</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>Ask:</span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>
//           “What does the primary survey show?” OR “What are the ABC’s?”
//         </strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Focus on the ABCs (Airway, Breathing, Circulation) and identify any
//         immediate life-threatening conditions. This is key for ALL ER visits, and
//         something you should make a habit of. When under duress, we sink to the
//         level of our training. ABC’s first. Note it down on your paper.&nbsp;
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//     </p>
//     <ol start={4}>
//       <li>
//         <strong> Quick Actions &amp; Interventions</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Based on the primary survey and chief complaint, decide if any emergent
//         interventions are needed:
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>
//           “I’d like to establish 2 large bore IV’s, oxygen and cardiac
//           monitoring.”
//         </strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           IV access
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Oxygen
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Cardiac monitoring
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Airway protection (if needed, consider preparing for intubation!)
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}> Fingerstick glucose</span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}> EKG</span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Other critical procedures or equipment
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Be decisive and act if your patient is in distress. The proctor is
//         expecting you to react to what is presented to you.&nbsp;
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//       <br />
//     </p>
//     <ol start={5}>
//       <li>
//         <strong> Gather the HPI (History of Present Illness)</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Time to ask why the patient is in today (if they’re able to tell you!):
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>
//           “What is the patient’s HPI?” or “Let’s ask the parent/patient why they
//           came in today”
//         </strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         This is your chance to gather the story—how, when, and why the patient
//         ended up in the ED. Ask any follow up questions you think are relevant
//         since the patient may not give you the whole story. Examples might
//         include:
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>“Did you have any falls/trauma?”</span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         “Any chest pain/vomiting/abdominal pain/urinary symptoms?”
//       </span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500 }}>“Is your tetanus up to date?”</span>
//     </p>
//     <p>
//       <br />
//       <br />
//     </p>
//     <ol start={6}>
//       <li>
//         <strong> Ask About Medical/Surgical History</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Get a thorough background by asking about:
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Medical history
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Surgical history
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Allergies
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Current medications
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         These details can provide critical context for the case.
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//       <br />
//     </p>
//     <ol start={7}>
//       <li>
//         <strong> Perform a Physical Exam</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Start by declaring your intention to examine the patient:
//       </span>
//     </p>
//     <p>
//       <strong>“I would like to perform a physical exam now.”</strong>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <strong>Then get specific:</strong>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         “Let’s start with the General Exam.”
//       </span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         “What does the HEENT exam show?”
//       </span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500 }}>Etc. etc.&nbsp;</span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Have a system in place. If you don’t have one, go head to toe! Ask one by
//         one to make sure you don’t miss anything. As with the real EM Oral Boards
//         (and in life…) you will only know what you ask about/perform.&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         HEENT → Cardiac → Lungs → Chest → Abdomen → Rectal → GU → Extremity →
//         Neuro → Skin → Back
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Be sure to hold extra focus on targeted findings relevant to the patient’s
//         presentation.
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ol start={8}>
//       <li>
//         <strong> Order Labs &amp; Imaging</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Based on your assessment, ask for appropriate:
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Laboratory tests
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Imaging studies
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Be specific about what you want (e.g., CBC, CMP, chest X-ray, CT scan).
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ol start={9}>
//       <li>
//         <strong> Review Results</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>Ask:</span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>“What are the results of the labs and imaging I ordered?”</strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Carefully analyze the findings—they will often guide your next steps. You
//         may be asked to look at a media item (no sneak peeking otherwise!) if
//         presented to you.&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ol start={10}>
//       <li>
//         <strong> Perform Interventions</strong>
//       </li>
//     </ol>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Now’s the time to act if you haven’t already! Based on your findings,
//         perform what you need to in order to best care for your patient. This
//         might include things like:&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Procedures
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Medications
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           IV Fluids (specify!)&nbsp;
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           POC Ultrasound ex. FAST exam
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//           {" "}
//           Consult specialists
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         What is it that the patient needs? Go ahead and order it! If it makes a
//         meaningful change in the patient’s status, the proctor will inform you (or
//         you can ask!) or it may be a critical action that might produce no
//         immediate change (ex. Starting an antibiotic).&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ol start={11}>
//       <li>
//         <strong> Disposition the Patient</strong>
//       </li>
//     </ol>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Finally, decide on the patient’s disposition. Do they need to stay in the
//         hospital? Who do you need to speak with? This will typically end the
//         case.&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         “I’d like to admit the patient to the hospitalist”
//       </span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>Or</span>
//     </p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         “I’d like to consult the Surgical Team for appendicitis”
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500 }}> Admit to the hospital</span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}> Admit to ICU</span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Coordinate transfer to another facility for XYZ reason
//         </span>
//       </li>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Discharge home with follow-up instructions
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         Clearly state your plan and rationale.
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>
//         When you speak to the admitting/transfer team -{" "}
//       </span>
//       <strong>provide a thorough history</strong>
//       <span style={{ fontWeight: 500 }}>
//         , with your summary. It may sound something like,
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         *You consulted Surgical Team*&nbsp;
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
//         “Hi, yes, this is a 66 year old female who presented with RLQ pain and
//         fever. We did some blood work and her labs showed leukocytosis but was
//         otherwise unremarkable. Her CT scan is consistent with appendicitis. We
//         gave 1g Ceftriaxone, 1g Acetaminophen IV, and 2L of Normal Saline and kept
//         her NPO status. She has no previous surgical history. I am consulting for
//         definitive care for appendicitis.”
//       </span>
//     </p>
//     <p>
//       <br />
//       <br />
//       <br />
//     </p>
//     <p>
//       <strong>Pro Tips for Success</strong>
//     </p>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Stay calm and methodical—don’t skip steps if there’s nothing urgent to
//           intervene on. You’ll confuse the proctor and yourself&nbsp;
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Be specific with your questions and requests
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Always reassess the patient after interventions if the proctor does not
//           tell you the outcome
//         </span>
//       </li>
//     </ul>
//     <p>&nbsp;</p>
//     <ul>
//       <li>
//         <span style={{ fontWeight: 500 }}>
//           {" "}
//           Keep the big picture in mind: Stabilize, diagnose, treat, and
//           disposition
//         </span>
//       </li>
//     </ul>
//     <p>
//       <br />
//       <br />
//     </p>
//     <p>
//       <strong>Final Thoughts</strong>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <em>
//         <span style={{ fontWeight: 500 }}>Critical Cases</span>
//       </em>
//       <span style={{ fontWeight: 500 }}>
//         {" "}
//         is all about practice and refinement. Follow the guide, think critically,
//         and communicate clearly. The more cases you tackle, the more confident and
//         efficient you’ll become.
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ backgroundColor: "#ffcc99" }}>
//         <strong>Now, go save some virtual lives. You’ve got this.</strong>
//       </span>
//     </p>
//     <p>&nbsp;</p>
//     <p>
//       <span style={{ fontWeight: 500 }}>Happy Practicing!</span>
//     </p>
//   </div>
  


//     );
// }

// export default Notes;

import React from 'react';

function Guide() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', lineHeight: 1.6 }}>
      
      <p><strong>A Guide to Critical Cases</strong></p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Congratulations on taking the next step in mastering your Emergency
          Medicine skills! Critical Cases is your virtual EM Oral Boards practice
          platform, designed to simulate real-world scenarios with an interactive
          virtual proctor. Whether you’re preparing for exams or sharpening your
          clinical decision-making, this guide will walk you through how to maximize
          your experience.
        </span>
      </p>
      <p><span style={{ fontWeight: 500 }}>Let’s dive in.</span></p>

      <p><strong>Getting Started</strong></p>
      <p>
        <span style={{ fontWeight: 500 }}>
          You’ll interact with the virtual proctor through a{' '}
        </span>
        <em><span style={{ fontWeight: 500 }}>chat/speech</span></em>
        <span style={{ fontWeight: 500 }}> interface.</span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>Just type (or speak!) your questions and requests.</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          The proctor will respond in real-time, providing details, updates, and
          test results based on your requests.
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Remember: The order in which you approach the case is crucial. Stick to
          the structure below for a smooth, logical flow.
        </span>
      </p>

      <p><strong>Step-by-Step Guide to Success</strong></p>

          <strong>1. Entering the Room: Set the Scene</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          We recommend you start every case with this question:
        </span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>“When I walk into the room, what do I see, hear, and smell?”</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          This will give you your first impression of the patient’s condition and
          environment. You might hear something like{' '}
        </span>
        <em>
          <span style={{ fontWeight: 500 }}>
            “The patient appears stated age, resting on the stretcher, appears to be
            grimacing from pain but otherwise in no significant distress.”
          </span>
        </em>
      </p>


          <strong>2. Get the Vitals</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Vital signs are…well…vital! Ask for those next!
        </span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>“What are the patient’s vital signs?”</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Vitals are the foundation of your assessment and will often guide your
          next steps. If you’re practicing for oral boards, be sure to jot these
          down on your paper at the top.
        </span>
      </p>


          <strong>3. Perform a Primary Survey</strong>

      <p>
        <span style={{ fontWeight: 500 }}>Ask:</span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>“What does the primary survey show?” OR “What are the ABC’s?”</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Focus on the ABCs (Airway, Breathing, Circulation) and identify any
          immediate life-threatening conditions. This is key for ALL ER visits.
          ABC’s first. Note it down.
        </span>
      </p>


          <strong>4. Quick Actions &amp; Interventions</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Based on the primary survey and chief complaint, decide if any emergent
          interventions are needed:
        </span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>“I’d like to establish 2 large bore IV’s, oxygen and cardiac monitoring.”</strong>
        </span>
      </p>
      <ul>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> IV access</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Oxygen</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Cardiac monitoring</span></li>
        <li><span style={{ fontWeight: 500 }}> Airway protection (if needed)</span></li>
        <li><span style={{ fontWeight: 500 }}> Fingerstick glucose</span></li>
        <li><span style={{ fontWeight: 500 }}> EKG</span></li>
        <li><span style={{ fontWeight: 500 }}> Other critical procedures or equipment</span></li>
      </ul>
      <p>
        <span style={{ fontWeight: 500 }}>
          Be decisive and act if your patient is in distress. The proctor is
          expecting you to react.
        </span>
      </p>


          <strong>5. Gather the HPI (History of Present Illness)</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Time to ask why the patient is in today (if they’re able to tell you!):
        </span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>
            “What is the patient’s HPI?” or “Let’s ask the parent/patient why they
            came in today”
          </strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          This is your chance to gather the story—how, when, and why the patient
          ended up in the ED. Ask any follow-up questions you think are relevant.
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>“Did you have any falls/trauma?”</span><br />
        <span style={{ fontWeight: 500 }}>“Any chest pain/vomiting/abdominal pain/urinary symptoms?”</span><br />
        <span style={{ fontWeight: 500 }}>“Is your tetanus up to date?”</span>
      </p>


          <strong>6. Ask About Medical/Surgical History</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Get a thorough background by asking about:
        </span>
      </p>
      <ul>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Medical history</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Surgical history</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Allergies</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Current medications</span></li>
      </ul>
      <p>
        <span style={{ fontWeight: 500 }}>
          These details can provide critical context for the case.
        </span>
      </p>


          <strong>7. Perform a Physical Exam</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Start by declaring your intention to examine the patient:
        </span>
      </p>
      <p><strong>“I would like to perform a physical exam now.”</strong></p>
      <p><strong>Then get specific:</strong></p>
      <p>
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          “Let’s start with the General Exam.”
        </span><br />
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          “What does the HEENT exam show?”
        </span><br />
        <span style={{ fontWeight: 500 }}>Etc. etc.&nbsp;</span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Have a system in place. If you don’t have one, go head to toe! As with
          the real EM Oral Boards, you only know what you specifically ask about.
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          HEENT → Cardiac → Lungs → Chest → Abdomen → Rectal → GU →
          Extremity → Neuro → Skin → Back
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Focus on targeted findings relevant to the patient’s presentation.
        </span>
      </p>


          <strong>8. Order Labs &amp; Imaging</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Based on your assessment, ask for appropriate:
        </span>
      </p>
      <ul>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Laboratory tests</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Imaging studies</span></li>
      </ul>
      <p>
        <span style={{ fontWeight: 500 }}>
          Be specific about what you want (e.g., CBC, CMP, chest X-ray, CT scan).
        </span>
      </p>


          <strong>9. Review Results</strong>

      <p><span style={{ fontWeight: 500 }}>Ask:</span></p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>“What are the results of the labs and imaging I ordered?”</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          Carefully analyze the findings—often they guide your next steps. You may
          be asked to look at media if presented.
        </span>
      </p>


          <strong>10. Perform Interventions</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Now’s the time to act if you haven’t already! Based on your findings,
          perform what you need. This might include:
        </span>
      </p>
      <ul>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Procedures</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Medications</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> IV Fluids (specify!)</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> POC Ultrasound (FAST exam)</span></li>
        <li><span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}> Consult specialists</span></li>
      </ul>
      <p>
        <span style={{ fontWeight: 500 }}>
          If an intervention changes the patient’s status, the proctor will let you
          know (or you can ask!).
        </span>
      </p>


          <strong>11. Disposition the Patient</strong>

      <p>
        <span style={{ fontWeight: 500 }}>
          Finally, decide on the patient’s disposition. Do they need to stay in
          the hospital? This typically ends the case.
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          “I’d like to admit the patient to the hospitalist”
        </span><br />
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          or
        </span><br />
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          “I’d like to consult the Surgical Team for appendicitis”
        </span>
      </p>
      <ul>
        <li><span style={{ fontWeight: 500 }}>Admit to the hospital</span></li>
        <li><span style={{ fontWeight: 500 }}>Admit to ICU</span></li>
        <li><span style={{ fontWeight: 500 }}>Coordinate transfer to another facility</span></li>
        <li><span style={{ fontWeight: 500 }}>Discharge home with follow-up instructions</span></li>
      </ul>
      <p>
        <span style={{ fontWeight: 500 }}>
          Clearly state your plan and rationale.
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>
          When you speak to the admitting/transfer team, <strong>provide a thorough history</strong> 
          with your summary. It may sound like:
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500, backgroundColor: "#ffcc99" }}>
          “Hi, this is a 66-year-old female with RLQ pain and fever. Labs showed
          leukocytosis; CT consistent with appendicitis. We administered 1g
          Ceftriaxone, 1g Acetaminophen IV, and 2L Normal Saline, kept her NPO.
          She has no previous surgical history. I’m consulting for definitive care
          for appendicitis.”
        </span>
      </p>

      <p><strong>Pro Tips for Success</strong></p>
      <ul>
        <li>
          <span style={{ fontWeight: 500 }}>
            Stay calm and methodical—don’t skip steps if nothing is urgent. 
            You’ll confuse the proctor and yourself.
          </span>
        </li>
        <li>
          <span style={{ fontWeight: 500 }}>
            Be specific with your questions and requests.
          </span>
        </li>
        <li>
          <span style={{ fontWeight: 500 }}>
            Always reassess the patient after interventions if the proctor doesn’t update you.
          </span>
        </li>
        <li>
          <span style={{ fontWeight: 500 }}>
            Keep the big picture in mind: Stabilize, diagnose, treat, and disposition.
          </span>
        </li>
      </ul>

      <p><strong>Final Thoughts</strong></p>
      <p>
        <em><span style={{ fontWeight: 500 }}>Critical Cases</span></em>
        <span style={{ fontWeight: 500 }}>
          &nbsp;is all about practice and refinement. Follow the guide, think critically,
          and communicate clearly. The more cases you tackle, the more confident and
          efficient you’ll become.
        </span>
      </p>
      <p>
        <span style={{ backgroundColor: "#ffcc99" }}>
          <strong>Now, go save some virtual lives. You’ve got this.</strong>
        </span>
      </p>
      <p>
        <span style={{ fontWeight: 500 }}>Happy Practicing!</span>
      </p>

    </div>
  );
}

export default Guide;
